<template>
	<div v-if="qualificationInfo && qualificationInfo.length" class="qualification-info">
		<div class="qualification-title">已选择资质信息</div>
		<div class="qualification-content">
			<div v-for="(group, groupIndex) in qualificationInfo" :key="groupIndex" class="qualification-group">
				<div class="group-name">{{ group.groupName }}：</div>
				<div class="qualification-items">
					<span v-for="(item, itemIndex) in group.collection" :key="itemIndex" class="qualification-item">
						{{ item.dictionaryValues }}
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// 资质诊断-已选择资质信息
	export default {
		name: 'HasSelectdQualification',
		components: {},
		props: {
			// 资质信息
			qualificationInfo: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped>
	.qualification-info {
		margin-bottom: 20px;
		border: 1px solid #e4e7ed;
		border-radius: 4px;
		padding: 15px;
		background-color: #f5f7fa;

		.qualification-title {
			font-size: 16px;
			font-weight: 500;
			color: #333;
			margin-bottom: 10px;
			padding-bottom: 10px;
			border-bottom: 1px solid #dcdfe6;
		}

		.qualification-content {
			.qualification-group {
				display: flex;
				// margin-bottom: 8px;

				.group-name {
					font-size: 15px;
					font-weight: 500;
					min-width: 120px;
				}

				.qualification-items {
					display: flex;
					flex-wrap: wrap;
					flex: 1;

					.qualification-item {
						margin-right: 10px;
						margin-bottom: 5px;
						padding: 2px 8px;
						background-color: #ecf5ff;
						color: #409eff;
						border-radius: 4px;
						font-size: 15px;
					}
				}
			}
		}
	}
</style>
